import { takeLatest, call, put, all } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as types from './constants';

export function* watchForPrompt() {
  yield takeLatest(types.SEND_PROMPT_REQUEST, sendPrompt);
}
export function* watchForModify() {
  yield takeLatest(types.MODIFY_SQL_REQUEST, modifySQL);
}

export function* watchForSuggest() {
  yield takeLatest(types.GET_SUGGESTION_REQUEST, getSuggestion);
}
export function* watchForFetch() {
  yield takeLatest(types.FETCH_DATA_REQUEST, getQuery);
}
export function* watchForUpvote() {
  yield takeLatest(types.UPVOTE_QUERY_REQUEST, upvoteQuery);
}
export function* watchForLog() {
  yield takeLatest(types.SEND_LOG_REQUEST, sendLog);
}



export function* sendPrompt({ payload, callback, sendPromptApi }) {
  try {
    const response = yield call(sendPromptApi, {
      ...payload,
    });
    yield put({
      type: types.SEND_PROMPT_SUCCESS,
      payload: {
        ...payload,
        ...response,
        status: 'QUERY',
      },
    });
    callback && callback(response);
  } catch (error) {
    yield put({
      type: types.SEND_PROMPT_FAILURE,
      payload,
    });
  }
}

export function* modifySQL({ modifySQLApi, payload, callback }) {
  try {
    const { org_id, prompt } = payload;
    const response = yield call(modifySQLApi, {
      ...payload,
      org_id,
      prompt,
    });
    yield put({
      type: types.MODIFY_SQL_SUCCESS,
      payload: {
        ...payload,
        ...response,
        status: 'QUERY',
      },
    });
    callback && callback(response);
  } catch (error) {
    yield put({
      type: types.MODIFY_SQL_FAILURE,
      payload,
    });
  }
}

export function* getSuggestion({ payload, callback, getSuggestionApi }) {
  const { org_id, prompt } = payload;
  try {
    const response = yield call(getSuggestionApi, {
      prompt,
      org_id,
      suggested: '',
      suggestions: [],
    });
    const res = { ...payload, suggestion: response };
    yield put({
      type: types.GET_SUGGESTION_SUCCESS,
      payload: {
        ...payload,
        suggestion: response,
      },
    });
    callback && callback(res);
  } catch (error) {
    yield put({
      type: types.GET_SUGGESTION_FAILURE,
      payload,
    });
  }
}

export function* getQuery({ fetchDataApi, payload }) {
  try {
    const { org_id, query, id, callback } = payload;
    const res = yield call(fetchDataApi, {
      org_id,
      query,
    });
    if (res?.response)
      yield put({
        type: types.FETCH_DATA_SUCCESS,
        payload: {
          response: res?.response,
          ftp_link: res?.ftp_link,
          piData: res?.piData,
          column_index: res?.column_index,
          id,
          status: 'RESPONSE',
        },
      });
    else {
      callback && callback(res?.errorLog);
      yield put({
        type: types.FETCH_DATA_FAILURE,
        payload: {
          ...payload,
          errorLog: res.errorLog,
        },
      });
    }
  } catch (error) {
    yield put({
      type: types.FETCH_DATA_FAILURE,
      payload,
    });
  }
}

export function* upvoteQuery({
  upvoteQueryApi,
  downvoteQueryApi,
  prompt,
  query,
  callback,
  feedback,
}) {
  try {
    const url = feedback === 'LIKE' ? upvoteQueryApi : downvoteQueryApi;

    const response = yield call(url, {
      ...types.baseReqObject,
      prompt,
      query,
    });

    yield put({
      type: types.UPVOTE_QUERY_SUCCESS,
    });
    callback && callback(response);
  } catch (error) {
    yield put({
      type: types.UPVOTE_QUERY_FAILURE,
    });
  }
}
export function* sendLog({ sendLogApi, payload, callback }) {
  try {
    const response = yield call(sendLogApi, {
      ...payload,
    });
    yield put({
      type: types.SEND_LOG_SUCCESS,
    });
    callback && callback(response);
  } catch (error) {
    yield put({
      type: types.SEND_LOG_FAILURE,
    });
  }
}

export default [
  watchForPrompt,
  watchForSuggest,
  watchForFetch,
  watchForModify,
  watchForUpvote,
  watchForLog,
];
